import { Box, Grid2, Typography } from "@mui/material"
import CustomIcon from "../../../Components/CustomIcon"

const AlertHistoryComment = ({comment}) => {
    return (
        <Grid2 container flexDirection={'column'} gap={0.5} sx={{bgcolor: '#F9F9F9', p: 1.5, borderRadius: '8px'}}>
            <Grid2 container gap={1.25} alignItems={'flex-end'}>
                <CustomIcon name="comment-icon" />
                <Typography variant="fw400s14lh20c2E2E2E" sx={{fontWeight: '600'}}>Comment:</Typography>
            </Grid2>
            <Box sx={{pl: 3.25}}>
                <Typography variant="fw400s14lh20c2E2E2E">{comment}</Typography>
            </Box>
        </Grid2>
    )
}

export default AlertHistoryComment;
